import { OPERATION_MACHINE_LINK_TYPE, OPERATION_MACHINE_LINK_TYPE_PRIORITIES } from '@helpers';
import { OperationSearchItem } from '@interfaces/search';

const getMachineLabelByLinkType = (linkType: string | undefined): string => {
  switch (linkType) {
    case OPERATION_MACHINE_LINK_TYPE.ProducedOn:
      return 'Produced On';
    case OPERATION_MACHINE_LINK_TYPE.ScheduledOn:
      return 'Scheduled On';
    case OPERATION_MACHINE_LINK_TYPE.Preferred:
      return 'Preferred Machine';
    default:
      return 'Machine';
  }
};

export const useGetMachineByJob = (job: OperationSearchItem | undefined) => {
  if (job == null) return null;

  // const jobStatus = job?.status;
  // const jobNotStarted = jobStatus === JOB_STATUSES.NOT_STARTED;
  const machines = job?.machines ?? [];

  const sortedMachines = machines
    .filter((machine) => machine.linkType && OPERATION_MACHINE_LINK_TYPE_PRIORITIES?.[machine.linkType])
    .sort((a, b) => {
      const priorityA = OPERATION_MACHINE_LINK_TYPE_PRIORITIES[a.linkType] || 999;
      const priorityB = OPERATION_MACHINE_LINK_TYPE_PRIORITIES[b.linkType] || 999;
      return priorityA - priorityB;
    });

  const machine = sortedMachines.length > 0 ? sortedMachines[0] : null;

  return {
    machine,
    label: getMachineLabelByLinkType(machine?.linkType),
  };
};
